<div mat-dialog-content>
  <div class="mat-dialog-content">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="row">
        <div class="col-md-12">
          <div class="body-confirm-modal-list">
            <div class="title-header">
              <h1>Checagem</h1>
            </div>

            @if (!isMedicatedSolution) {
              <div>
                @if (prescriptionMedicineStruct.prescriptionMedicine.justification) {
                  <div class="justification-block">
                    <p class="warning"><mat-icon>warning</mat-icon><b>Paciente Alérgico</b></p>
                    <p>O paciente é alérgico a um dos princípios ativos deste medicamento</p>
                    <b>Justificativa:</b>
                    <p class="justification-text" [matTooltip]="prescriptionMedicineStruct.prescriptionMedicine.justification">{{prescriptionMedicineStruct.prescriptionMedicine.justification}}</p>
                  </div>
                }
              </div>
            }
            @if (isMedicatedSolution) {
              <div>
                @if (prescriptionSolutionStruct.prescriptionSolution.justification) {
                  <div class="justification-block">
                    <p class="warning"><mat-icon>warning</mat-icon><b>Paciente Alérgico</b></p>
                    <p>O paciente é alérgico a um dos princípios ativos deste medicamento</p>
                    <b>Justificativa:</b>
                    <p class="justification-text" [matTooltip]="prescriptionSolutionStruct.prescriptionSolution.justification">{{prescriptionSolutionStruct.prescriptionSolution.justification}}</p>
                  </div>
                }
              </div>
            }

            @if (this.isReadonly) {
              <div class="row">
                <div class="col-md-11">
                  <label>Checado em {{checkDatetimeFulfilled | date:'dd/MM/yyyy HH:mm'}}</label>
                  <p>{{checkProfessionName}} - {{checkUserName}}</p>
                </div>
              </div>
            }
            @if (data.actions) {
              <div class="row ">
                <div class="col-12 col-sm-4 col-md-5">
                  <mat-checkbox matInput formControlName="checkName" [disabled]="isReadonly"
                  [checked]="checkedPatient"></mat-checkbox>
                  <label>Nome do paciente</label>
                </div>
                <div class="col-12 col-sm-4 col-md-4 mobile-margin">
                  <label>Data de nascimento</label>
                </div>
              </div>
              <div class="row row-block">
                <div class="col-12 col-sm-4 col-md-5">
                  <p class="first-description">{{this.data.patientName}}</p>
                </div>
                <div class="col-12 col-sm-4 col-md-4 mobile-margin">
                  <p>{{this.data.birthDate | date:'dd/MM/yyyy'}}</p>
                </div>
                @if (!isReadonly) {
                  <div class="col-12 col-sm-3 col-md-2">
                    <button mat-flat-button type="button" color="primary" class="btn-primary read-btn"
                    (click)="openPatientBarCodeModal()">Ler paciente</button>
                  </div>
                }
              </div>
              <div class="row">
                <div class="col-12 col-sm-3 col-md-5">
                  <mat-checkbox matInput formControlName="checkMedication" [disabled]="isReadonly"
                    [checked]="checkedMedicine">
                  </mat-checkbox>
                  <label>Medicação</label>
                </div>
                <div class="col-12 col-sm-2 col-md-1 mobile-margin">
                  <label>Qtde.</label>
                </div>
                <div class="col-12 col-sm-3 col-md-3 mobile-margin">
                  <label>Unidade</label>
                </div>
              </div>
              @if (!isMedicatedSolution) {
                <div class="row row-block">
                  <div class="col-12 col-sm-3 col-md-5 mobile-margin">
                    <p class="first-description">{{prescriptionMedicineStruct.medicineName}}</p>
                  </div>
                  <div class="col-12 col-sm-2 col-md-1 mobile-margin">
                    <p>{{prescriptionMedicineStruct.prescriptionMedicine.quantity}}</p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-3 mobile-margin">
                    <p>{{prescriptionMedicineStruct.measurementUnitName}}</p>
                  </div>
                  @if (!isReadonly && data.actions) {
                    <div class="col-12 col-sm-3 col-md-2">
                      <button mat-flat-button type="button" color="primary" class="btn-primary read-btn"
                      (click)="openMedicineBarCodeModal(this.prescriptionMedicineStruct.prescriptionMedicine.idMedicine)">Ler medicação</button>
                    </div>
                  }
                </div>
              }
              @if (isMedicatedSolution) {
                <div class="row-block">
                  @for (item of prescriptionSolutionStruct.listSolutionMedicine; track item; let index = $index) {
                    <div class="row">
                      <div class="col-12 col-sm-3 col-md-5 mobile-margin first-description">
                        <div class="status-icon">
                          @if (item.idPrescriptionStatus == nonDispensedStatus) {
                            <mat-icon aria-hidden="false" aria-label="não dispensado" class="non-dispensed-status">close</mat-icon>
                          }
                          @if (item.idPrescriptionStatus == releasedStatus) {
                            <mat-icon aria-hidden="false" aria-label="não dispensado" [ngClass]="{'opened-status': this.model.get('checkMedication').value == true}">done</mat-icon>
                          }
                          @if (item.idPrescriptionStatus == openedStatus) {
                            <mat-icon aria-hidden="false" aria-label="não dispensado" matTooltip="Em aberto">info</mat-icon>
                          }
                        </div>
                        <p class="">{{item.medicineName}}</p>
                      </div>
                      <div class="col-12 col-sm-2 col-md-1 mobile-margin">
                        <p>{{item.prescriptionSolutionMedicine.quantity}}</p>
                      </div>
                      <div class="col-12 col-sm-3 col-md-3 mobile-margin">
                        <p>{{item.measurementUnitName}}</p>
                      </div>
                      @if (!isReadonly && data.actions) {
                        <div class="col-12 col-sm-3 col-md-2">
                          @if (item.idPrescriptionStatus != nonDispensedStatus) {
                            <button mat-flat-button type="button" color="primary" class="btn-primary read-btn"
                            (click)="openMedicineBarCodeModal(item.prescriptionSolutionMedicine.idMedicine)">Ler medicação</button>
                          }
                          @if (item.idPrescriptionStatus == nonDispensedStatus) {
                            <span class="non-dispensed-status warning-non-dispensed">Não dispensado</span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <div class="row">
                <div class="col-12 col-sm-2">
                  <mat-checkbox matInput formControlName="checkAdministration"
                    (change)="checkAdministration($event)" [disabled]="isReadonly">
                  </mat-checkbox>
                  <label>Via </label>
                </div>
              </div>
              <div class="row row-block">
                <div class="col-12 col-sm-2">
                  @if (!isMedicatedSolution) {
                    <p class="first-description">{{prescriptionMedicineStruct.administrationTypeName}}</p>
                  }
                  @if (isMedicatedSolution) {
                    <p class="first-description">{{prescriptionSolutionStruct.administrationTypeName}}</p>
                  }
                </div>
                <div class="col-12 col-sm-6">
                  @if (this.showLocal) {
                    <mat-form-field appearance="outline" [disabled]="isReadonly">
                      <mat-label>Local: </mat-label>
                      <input type="text" matInput formControlName="administrationLocal"
                        [disabled]="isReadonly">
                      </mat-form-field>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline">
                      <mat-label>Observações</mat-label>
                      <mat-select [disabled]="isReadonly" [(ngModel)]="observationSelect"
                        (selectionChange)="selectionChange()" [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="null">Selecione</mat-option>
                        @for (item of listPrescriptionObservationOnBed; track item) {
                          <mat-option [value]="item.idPrescriptionObservationOnBed">
                          {{item.description}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (this.showComplaints) {
                    <div class="col-12">
                      <mat-form-field appearance="outline" [disabled]="isReadonly">
                        <mat-label>Queixas/Intercorrências: </mat-label>
                        <textarea type="text" matInput formControlName="complaints"></textarea>
                        @if (model.get('complaints').invalid) {
                          <mat-error>Preencha a queixa!
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="title-flex">
          <h2>{{!completelyNonDispensated ? 'Prescrição' : 'Prescrição - Não dispensada pela farmácia'}}</h2>
          @if ((isMedicatedSolution && prescriptionSolutionStruct.listSolutionCheck && prescriptionSolutionStruct.listSolutionCheck.length > 0)
            || (!isMedicatedSolution && prescriptionMedicineStruct.listPrescriptionMedicineCheck && prescriptionMedicineStruct.listPrescriptionMedicineCheck.length > 0)) {
            <button type="button" mat-flat-button color="accent" class="btn" (click)="openCheckHistoryModal()"
              >
              <span>Ver histórico</span>
            </button>
          }
        </div>
        @if (!isMedicatedSolution) {
          <div class="row row-block">
            <app-prescricption-medicine-details [prescriptionMedicine]="prescriptionMedicineStruct"></app-prescricption-medicine-details>
          </div>
        }
        @if (isMedicatedSolution) {
          <div class="row row-block">
            <app-prescricption-solution-details [prescriptionSolution]="prescriptionSolutionStruct"></app-prescricption-solution-details>
          </div>
        }
        @if (listKit != null && listKit.length > 0) {
          <div class="card-list">
            <span class="kits-vinculed">Kits Vinculados:</span>
            <div class="row row-list">
              @for (item of listKit; track item; let index = $index) {
                <div class="col-12 col-sm-6">
                  <div class="card-item" [class.selected]="isKitSelected(item)">
                    <div class="infos">
                      <span class="primary">{{item.kit.kitName}}</span>
                      <span class="secundary">{{item.kitType.kitTypeName}}</span>
                    </div>
                    <div class="actions">
                      <mat-checkbox
                        [disabled]="true"
                        [checked]="isKitSelected(item)"
                        (change)="toggleKitSelection(item)">
                      </mat-checkbox>
                      <a class="view-icon" (click)="openKit(item)">
                        <mat-icon aria-hidden="false" aria-label="Visualizar">
                          visibility
                        </mat-icon>
                      </a>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </form>
    </div>
  </div>
  <div mat-dialog-footer class="footer-modal">
    <div class="footer-modal-list">
      <div class="row">
        <div [ngClass]="{'col-4': !this.modelIsDisable, 'col-12': this.modelIsDisable}">
          <button mat-flat-button type="button" color="accent" class="btn-block" (click)="close()">
            @if (isLoading == false) {
              <span>Fechar</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
        @if (!isPrescriptionExternal && !isReadonly && data.actions && this.canSuspend
          && ((!isMedicatedSolution && prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus != nonDispensedStatus
          && prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus != this.suspended)
          || (isMedicatedSolution && prescriptionSolutionStruct.idPrescriptionStatus != nonDispensedStatus
          && prescriptionSolutionStruct.idPrescriptionStatus != this.suspended))) {
          <div class="col-4">
            <button mat-flat-button color="accent" class="btn-block" type="button" (click)="suspendPrescriptionModal()">
              @if (isLoading == false) {
                <span>Suspender horário</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
              }
            </button>
          </div>
        }
        @if (!this.modelIsDisable) {
          <div class="col-4">
            @if (!isPrescriptionExternal && !isReadonly && data.actions
              && ((!isMedicatedSolution && prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus != nonDispensedStatus)
              || (isMedicatedSolution && prescriptionSolutionStruct.idPrescriptionStatus != nonDispensedStatus))) {
              <button mat-flat-button color="primary" class="btn-block" type="submit" (click)="submit()"
                >
                @if (isLoading == false) {
                  <span>Liberar</span>
                }
                @if (isLoading == true) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>